module.exports = __webpack_public_path__ + "img/12d.faa78a2a.jpeg";